<template lang="html">

  <div class="slds-progress-bar" aria-valuemin="0" aria-valuemax="100" v-bind:aria-valuenow="progress" role="progressbar">
    <span class="slds-progress-bar__value" v-bind:style=" 'width:'+progress+'%' ">
      <span class="slds-assistive-text">Progress: {{progress}}%</span>
    </span>
  </div>

</template>

<script>

export default {
  name: 'progressbar',
  components: {
  },
  computed: {
  },
  props: {
    progress: Number
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped>
</style>
